import React from "react";
import { useBlockLayout, useSortBy, useTable } from "react-table";
import { motion } from "framer-motion";
import { BiServer } from "react-icons/bi";
import { Table, Thead, Tr, Th, Tbody, Td, Center,  Text, Box } from "@chakra-ui/react";

import { Spinner } from "../../Loader";
const MotionRow = motion(Tr);

export default function ReportTable({ background = "gray.50", color = "gray.800", columns, ...props }) {
	let { data, isLoading } = props;

	const memorizedData = React.useMemo(() => (data ? data : [{}]), [data]);
	const defaultColumn = React.useMemo(
		() => ({
			width: 100,
		}),
		[]
	);

	const { getTableProps, getTableBodyProps, headerGroups,  rows, prepareRow } = useTable(
		{
			columns,
			data: memorizedData || [],
			defaultColumn,
		},
		useSortBy,
		useBlockLayout
	);

	return (
		<Box flex="1">
			<Table {...getTableProps()} size="sm" variant="simple">
				<Thead zIndex="2" pos="sticky" top="0" bg={background}>
					{headerGroups.map((headerGroup) => (
						<Tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column) => (
								<Th fontWeight="bold" py="4" {...column.getHeaderProps(column.getSortByToggleProps())} color={color}>
									{column.render("Header")}
									<span>{column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}</span>
								</Th>
							))}
						</Tr>
					))}
				</Thead>
				{isLoading ? (
					<Spinner />
				) : (
					<>
						<Tbody {...getTableBodyProps()}>
							{rows.length > 0 ? (
								<>
									{rows.map((row) => {
										prepareRow(row);
										return (
											<MotionRow
												initial={{ opacity: 0 }}
												animate={{ opacity: 1 }}
												transition={{ duration: 0.2 }}
												cursor="pointer"
												_hover={{ bg: "gray.50" }}
												{...row.getRowProps()}
											>
												{row.cells.map((cell) => (
													<Td style={{ cursor: "default" }} py="2" {...cell.getCellProps()}>
														{cell.render("Cell")}
													</Td>
												))}
											</MotionRow>
										);
									})}
								</>
							) : (
								<Tr>
									<Td colSpan={columns.length}>
										<Center py="1" w="full" h="full" color="gray.400">
											<BiServer size="1.1rem" /> <Text fontSize="md">&nbsp;No data.</Text>
										</Center>
									</Td>
								</Tr>
							)}
						</Tbody>
					</>
				)}
			</Table>
		</Box>
	);
}
